
import { useEffect, useMemo, useState } from "react";
import { Button, Card, CardActions, Box, Stack, Typography, Divider } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useNavigate } from "react-router-dom";

import ConfirmDialog from "../../../components/ConfirmDialog";
import useInternalFetch from "../../../api/apiInternal";
import config from "../../../common/Config";


const FILTER_MANIFEST = '/files/filters/index.json';

const CardFilter = (props) => {
	const navigate = useNavigate();
	const internalFetch = useInternalFetch();
	const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
	const [description, setDescription] = useState('');

	const cardImage = useMemo(() => {
		try {
			return require(`../../../images/filters/${props.id}.png`);
		} catch {
			return null;
		}
	}, [props.id]);

	useEffect(() => {
		let ignore = false;

		const loadDescription = async () => {
			try {
				const manifestResponse = await fetch(FILTER_MANIFEST);
				if (!manifestResponse.ok) return;
				const manifest = await manifestResponse.json();
				const fileName = manifest?.[String(props.id)];
				if (!fileName) return;
				const htmlResponse = await fetch(`/files/filters/${fileName}`);
				if (!htmlResponse.ok) return;
				const htmlContent = await htmlResponse.text();
				const plainText = htmlContent.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
				if (!ignore) setDescription(plainText);
			} catch (err) {
				// silencioso
			}
		};

		loadDescription();
		return () => { ignore = true };
	}, [props.id]);

	const handleRemove = () => setIsDeleteConfirmOpen(true);

	const deleteScreener = (pId) => {
		internalFetch(config.apiUrl + '/api/screener/' + pId, {
			method: 'DELETE',
			headers: { 'content-type': 'application/json; charset=utf-8' }
		})
		.then(result => {
			if (props.onDelete) props.onDelete(result.status);
		});
	};

	return (
		<Card sx={{ p: 2, display: 'flex', gap: 2 }}>
			<ConfirmDialog
				title="Aviso"
				children="Tem certeza que deseja excluir este filtro?"
				open={isDeleteConfirmOpen}
				setOpen={setIsDeleteConfirmOpen}
				onConfirm={() => deleteScreener(props.id)}
			/>
			{ cardImage ? (
				<Box
					component="img"
					src={cardImage}
					sx={{ width: 140, height: 210, borderRadius: 2, objectFit: 'cover', backgroundColor: 'grey.200', flexShrink: 0 }}
				/>					
			):(
				<Box
					sx={{
						width: 140,
						height: 210,
						borderRadius: 2,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						backgroundColor: '#b4b4b4',
						color: 'primary.main',
						flexShrink: 0
					}}
				>
					<FilterAltIcon sx={{ fontSize: 48, color: 'gray'}} />
				</Box>
			)}
			
			<Stack flex={1} spacing={1} justifyContent="space-between" sx={{ height: 210, minWidth: 0 }}>
				<Box>
					<Typography variant="h6" noWrap>{props.title}</Typography>
					<Typography variant="body2" color="text.secondary" noWrap>
						{props.subtitle}
					</Typography>
				</Box>
				<Divider sx={{ my: 1 }} />
				<Typography
					variant="body2"
					color="text.secondary"
					sx={{
						flexGrow: 1,
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						display: '-webkit-box',
						WebkitLineClamp: 6,
						WebkitBoxOrient: 'vertical',
						minHeight: 72
					}}
				>
					{description || props.description || 'Descrição não disponível.'}
				</Typography>
				<CardActions sx={{ justifyContent: 'flex-end', p: 0, gap: 1 }}>
					{props.onDelete ? (<Button variant="outlined" color="secondary" onClick={handleRemove} startIcon={<DeleteIcon />}>Remover</Button>) : null}
					<Button variant="contained" onClick={() => navigate('/stockscreener/' + props.id)}>Ver</Button>
				</CardActions>
			</Stack>
		</Card>
	);
};

export default CardFilter;
